import { asyncToGenerator as _asyncToGenerator } from '../_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from '../node_modules/regenerator-runtime/runtime.esm.js';
import { resolveURI } from '../utils/resolveURI.esm.js';
import { fetch } from '../utils/fetch.esm.js';
import { isImageURI } from '../utils/isImageURI.esm.js';
import '../utils/index.esm.js';

var URI = /*#__PURE__*/function () {
  function URI() {}

  var _proto = URI.prototype;

  _proto.getMetadata = /*#__PURE__*/function () {
    var _getMetadata = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(uri, options) {
      var _options$urlDenyList;

      var _resolveURI, resolvedURI, isOnChain, isImage, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _resolveURI = resolveURI(uri, options), resolvedURI = _resolveURI.uri, isOnChain = _resolveURI.isOnChain;

              if (!isOnChain) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", resolvedURI);

            case 3:
              if (!(options != null && (_options$urlDenyList = options.urlDenyList) != null && _options$urlDenyList.includes(new URL(resolvedURI).hostname))) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", {
                image: null
              });

            case 5:
              _context.next = 7;
              return isImageURI(resolvedURI);

            case 7:
              isImage = _context.sent;

              if (!isImage) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", {
                image: resolvedURI
              });

            case 10:
              _context.next = 12;
              return fetch(encodeURI(resolvedURI));

            case 12:
              response = _context.sent;
              _context.next = 15;
              return response == null ? void 0 : response.data;

            case 15:
              return _context.abrupt("return", _context.sent);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getMetadata(_x, _x2) {
      return _getMetadata.apply(this, arguments);
    }

    return getMetadata;
  }();

  return URI;
}();

export default URI;
//# sourceMappingURL=uri.esm.js.map
